import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { resolveProductDisplayName } from '../../utils/productName';
import { getTranslated } from '../../utils/translations';
import LangLink from '../navigation/LangLink';

const Product_component = (props) => {
  const result = props.data ?? {};
  const { i18n } = useTranslation();
  const displayName = resolveProductDisplayName(result?.nome_articolo, result?.p_name);

  // Mantiene l'ultimo conteggio valido per evitare flicker a 0
  const lastValidCountRef = useRef(Number(result?.somma_colori) || 0);

  const cfg = result?.configid;
  const map = props.somma_colori_data;

  // Se la mappa contiene una voce per questo configid, aggiorna il ref (accetta anche 0)
  if (map && cfg !== undefined && Object.prototype.hasOwnProperty.call(map, cfg)) {
    const n = Number(map[cfg]);
    if (Number.isFinite(n)) {
      lastValidCountRef.current = n;
    }
  }

  const extraColors = lastValidCountRef.current;

  return (
    <LangLink to={`/${result?.slug}/${result?.id}`} style={{ position: 'relative' }}>
      <div className="product_item">
        <div 
          className="product_img"
          style={{ backgroundImage: `url(${result?.product_image || '/images/artic_06.jpg'})` }}
          aria-label="Immagine"
        ></div>
        <div className="product_data" style={{ position: 'static', bottom: '0' }}>
          <span className="tag">{displayName}</span>
          <p className="name">
            {result?.perc_1?.replaceAll('.0', '')}
            {result.perc_1 ? '% ' : ''}
            {getTranslated(i18n, result, { en: 'fibra_1_en', it: 'fibra_1 ' }, 'fibra_1')}
            {result.fibra_2 ? ' - ' : ''}
            {result?.perc_2 != 0 ? (
              <>
                {result?.perc_2?.replaceAll('.0', '')}
                {result.perc_2 ? '% ' : ''}
              </>
            ) : (
              ''
            )}
            {getTranslated(i18n, result, { en: 'fibra_2_en', it: 'fibra_2 ' }, 'fibra_2')}
            {result.fibra_3 ? ' - ' : ''}
            {result?.perc_3 != 0 ? (
              <>
                {result?.perc_3?.replaceAll('.0', '')}
                {result.perc_3 ? '% ' : ''}
              </>
            ) : (
              ''
            )}
            {getTranslated(i18n, result, { en: 'fibra_3_en', it: 'fibra_3 ' }, 'fibra_3')}
            {result.fibra_4 ? ' - ' : ''}
            {result?.perc_4 != 0 ? (
              <>
                {result?.perc_4?.replaceAll('.0', '')}
                {result.perc_4 ? '% ' : ''}
              </>
            ) : (
              ''
            )}
            {getTranslated(i18n, result, { en: 'fibra_4_en', it: 'fibra_4 ' }, 'fibra_4')}
          </p>

          <div className="item_color">
            <p className="count">
              <span>+{extraColors}</span>
            </p>
            <p className="color">
              <span className="red" />
              <span className="yellow" />
              <span className="blue" />
            </p>
          </div>
        </div>
      </div>
    </LangLink>
  );
};

export default Product_component;
